/**
 * @generated SignedSource<<8f597425d7d90164a56e0e876422ac3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleTypeformArticle$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"hooksIsShowTypeformArticle">;
  readonly " $fragmentType": "articleTypeformArticle";
};
export type articleTypeformArticle$key = {
  readonly " $data"?: articleTypeformArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleTypeformArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleTypeformArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksIsShowTypeformArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "cfb76ce58807ec75324d853fd9828341";

export default node;
